module.exports = {"532327101":"永定镇","532327102":"宜就镇","532327103":"中和镇","532327201":"莲池乡","532327202":"维的乡","532327203":"猛虎乡","532327204":"永兴傣族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532327.json
// module id = 2756
// module chunks = 0